
// export default EditOwnerModel;
import React, { useEffect, useState } from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import { toast } from "react-toastify";
import CircularProgress from '@mui/material/CircularProgress';


const validationSchema = Yup.object().shape({
  // email: Yup.string().email("Invalid email").required("Email is required"),
  // password: Yup.string()
  //   .min(8, "Password must be at least 8 characters")
  //   .matches(/[A-Za-z]/, "Password must contain at least one letter")
  //   .matches(/[0-9]/, "Password must contain at least one number")
  //   .required("Password is required"),
  // client: Yup.string().required("Client selection is required"),
  mobile: Yup.string().required("Please enter mobile no."),
  name: Yup.string().required("Please enter name"),
  city: Yup.string().required("Please select  city"),
  propertyCount: Yup.string().required("Please select property no."),
});

const AddOwner = ({
  onMutateRegister,
  isRegisterLoading,
  setRegisterUser,
  addOwnerMutate,
  apiData,
  handleChange,
  setAddOwner,
  setSelectedData,
}) => {
  const initialValues = {

    name: "",
    mobile: "",
    city: "",
    propertyCount: ""

  };

  const [clientOptions, setClientOptions] = useState([]);
  // const [name, setName] = useState("");
  // const handleChange = (e) => {
  //   const value = e.target.value;
  //   // Allow only alphabets and spaces
  //   if (/^[A-Za-z\s]*$/.test(value)) {
  //     setName(value);
  //   }
  // };
  useEffect(() => {
    if (apiData) {
      setClientOptions(
        apiData.map((client) => ({ id: client.id, name: client.name }))
      );
    }
  }, [apiData]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      // onMutateRegister(values);

      addOwnerMutate(values);
      console.log("values ", values);
      // setSubmitting(false);
    },
  });

  return (
    <Model width="w-11/12 max-w-md" setOpenModel={setAddOwner}>

      <FormWrapper>
        <Title>Add Owner</Title>
        <form onSubmit={formik.handleSubmit}>


          <FormWrapper>
            <InputGroup>
              <Label htmlFor="name">Name</Label>
              <Input
                name="name"
                type="text"
                placeholder="Enter Owner Name"
                value={formik.values.name}
                onChange={(e) => {
                  // Remove numbers from input
                  const value = e.target.value.replace(/[0-9]/g, "");
                  formik.setFieldValue("name", value);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.name && formik.errors.name && (
                <ErrorText>{formik.errors.name}</ErrorText>
              )}
            </InputGroup>

            <InputGroup>
              <Label htmlFor="mobile">Mobile</Label>
              <Input
                name="mobile"
                type="mobile"
                placeholder="Enter Owner Mobile Number"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                maxLength={10}
                pattern="[0-9]{10}"
              // onBlur={formik.handleBlur}
              />
              {formik.touched.mobile && formik.errors.mobile && (
                <ErrorText>{formik.errors.mobile}</ErrorText>
              )}
            </InputGroup>
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="propertyCount">No. of Properties</Label>
                <Select
                  className="w-full pl-2 rounded-lg"
                  name="propertyCount"
                  type="propertyCount"
                  placeholder="NO. of properties you own"
                  value={formik.values.propertyCount}
                  onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                </Select>
                {formik.touched.propertyCount && formik.errors.propertyCount && (
                  <ErrorText>{formik.errors.propertyCount}</ErrorText>
                )}
              </InputGroup>
              <InputGroup>
                <Label htmlFor="city">City</Label>
                <Select
                  className="w-full pl-2 rounded-lg"
                  name="city"
                  placeholder="Select City"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                >
                  <MenuItem value="New Delhi">New Delhi</MenuItem>
                  <MenuItem value="Pune">Pune</MenuItem>
                  <MenuItem value="Banglore">Banglore</MenuItem>
                  <MenuItem value="Hyderabad">Hyderabad</MenuItem>
                  <MenuItem value="Mumbai">Mumbai</MenuItem>
                  <MenuItem value="Noida">Noida</MenuItem>
                  <MenuItem value="Gurugram">Gurugram</MenuItem>
                  <MenuItem value="Ahmedabad">Ahmedabad</MenuItem>
                </Select>
                {formik.touched.city && formik.errors.city && (
                  <ErrorText>{formik.errors.city}</ErrorText>
                )}
              </InputGroup>
            </CombineInputGroup>
          </FormWrapper>

          <BtnWrapper>
            <SubmitBtn type="submit" >
              {isRegisterLoading ? <Loading height={16} width={16} noPadding={true} /> : "Add Owner"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </FormWrapper>

    </Model>
  );
};

// const Label = tw.label`block text-sm font-medium text-gray-700 mb-1`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const Button = tw.button`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-color hover:bg-hover-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50`;
const ErrorText = tw.div`text-red-500 text-sm`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const CombineInputGroup = tw.div`flex space-x-7`;
const FormWrapper = tw.div`px-1  space-y-3 `;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;

export default AddOwner;
